import './Header.css';
import React from "react";
import generateDate from "../assets/functions/generateDate.js"


function Header(props) {
    let generateDateResponse=generateDate()
    const todaysDate = generateDateResponse[0]
    const dayOfWeek = generateDateResponse[1]
    const dayNumber = [7, 1, 2, 3, 4, 5, 6]

    return (
        <div className="header">
            <div className="headerRow">
                <p onClick={() => props.setActivePage("goals")} className={props.activePage === "goals" ? "pageTab activePageTab" : "pageTab"}> | profile |</p>
                <p onClick={() => props.setActivePage("tasks")} className={props.activePage === "tasks" ? "pageTab activePageTab" : "pageTab"}>| tasks |</p>
                <p onClick={() => props.setActivePage("content")} className={props.activePage === "content" ? "pageTab activePageTab" : "pageTab"}>| day {dayNumber[dayOfWeek]} | {todaysDate} |</p>
                <p onClick={() => props.setActivePage("sprint")} className={props.activePage === "sprint" ? "pageTab activePageTab" : "pageTab"}>| sprint cycle |</p>
            </div>
            <div className="dottedLine"></div>
        </div>
    )
}

export default Header;